import styled from '@emotion/styled';
import Icon from '@icon/Icon';

const StyledIcon = styled(Icon)`
  fill: none;
`;

const CheckboxToggle = (props) => {
  const { color, fill, ...rest } = props;
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <StyledIcon viewBox="0 0 24 24" {...rest}>
      <rect
        x="3"
        y="3"
        width="18"
        height="18"
        rx="3"
        fill={fill}
        stroke={color}
        strokeWidth="2"
      />
    </StyledIcon>
  );
};

export default CheckboxToggle;
